
















































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import * as Common from '@/agiles/common';
import * as Components from '@/agiles/components';


// タブ表示が可能な汎用エディタ機能を提供します。実行アクションなどはバインドします。必要に応じてクローン済みのオブジェクトをセットしてください。
@Component
export default class Editor extends Vue implements Components.IEditor {
  @Prop() public item: Common.ObjectBase;
  @Prop() public tabs?: string[];
  @Prop({ default: () => new Array() }) public tabVisibles?: boolean[];
  @Prop({ default: () => new Array() }) public tabTooltips?: boolean[];  
  @Prop({ default: null }) public perm: string;
  @Prop({ default: false }) public editVisible: boolean;
  @Prop({ default: true }) public spEditVisible: boolean;  
  @Prop({ default: false }) public closeVisible: boolean;
  @Prop({ default: true }) public spCloseVisible: boolean;    
  @Prop({ default: '更新する' }) public execCaption: string;
  @Prop({ default: null }) public owner: Components.ListView;
  // @Prop({ default: true }) public autoScroll: boolean;
  @Prop({ default: false }) public isFullSizeEditor: boolean;
  @Prop({ default: true }) public tooltipVisible: boolean;  

  public get isAdminSite() :boolean{
    return Common.Api.siteMode == Common.siteModes.admin;
  }
  public get columnStyle() : boolean {
    return this.owner && this.tabs.length > 1 && ((this.owner.dialogMode && this.$api.innerHeight >= 800) ||  (this.owner.dialogMode == false && this.owner.columnStyle  && this.$api.innerHeight >= 720) );
  }

  public adjust(list : any[]){
    //タブ側で初期化される場合があるので、クローンしたものを渡す必要がある
    if (list) return this.columnStyle && list.length > 0 ? list.slice(1) : list.slice(0);
    else return [];
  }
  public isMinimized:boolean = false;
  public onResize(){
    this.$nextTick(()=>{
      if(this.$el.clientHeight < 100 && this.$api.spMode == false) this.isMinimized = true;
      else this.isMinimized = false;
    });
  }
  public tooltip?: string;
  public tooltipIsAlert:boolean = false;
  public tabInvalids:boolean[] = [] ;
  public editorState: Common.editorStates = Common.editorStates.Read;
  public actionDisabled: boolean = false;
  public get isActionState(): boolean {
    return this.editorState != Common.editorStates.Read;
  }
  public get isActionState2(): boolean {
    return this.editorState != Common.editorStates.Read || (this.$api.spMode && this.spEditVisible);
  }
  public get isActionState3(): boolean {
    return this.editorState != Common.editorStates.Read || (this.$api.spMode && this.spCloseVisible);
  }
  public actionTooltipVisible : boolean = true;

  //ボタンキャプション
  public executeMessage: string = '編集する';
  public executeIcon: string = null;
  public cancelMessage: string = '';
  public cancelIcon: string = null;

  //イベントターゲット
  private source: HTMLElement;
  private target: HTMLElement;

  //#region コントロールバリデーション

  public validator: Components.Validator = new Components.Validator();
  public controls: Components.IControl[] = new Array();

  public addControl(control: Components.IControl) {
    if (control.validator != null) {
      this.validator.Validators.push(control.validator);
    }
    control.isEdit = this.isEdit;
    this.controls.push(control);
  }
  public removeControl(control: Components.IControl){
    if (control.validator != null) {
      var index = this.validator.Validators.indexOf(control.validator);
      if (index != -1) this.validator.Validators.splice(index, 1);
    }    
    var index1 = this.controls.indexOf(control);
    if (index1 != -1) this.controls.splice(index1, 1);    
  }
  //#endregion


  // public get statusList():string{
  //   if (this.owner && this.owner.$refs && this.owner.$refs.listBox)
  //   {
  //      var gridItem = (this.owner.$refs.listBox as Vue).$children.find(obj=>obj.$children != null && obj.$children.length > 0 && obj.$children[0].$el.className == '');   
  //      if(gridItem) return (gridItem.$children[0] as Components.Badge).list;
  //   }
  //   return null;
  // }
  //#region　フォーカス制御～Read以外の場合に確認ダイアログを表示する

  public created() {
    document.body.addEventListener('click', this.onClickOtherElement, { capture: true });
    document.body.addEventListener('focusin', this.onClickOtherElement, { capture: true });
    if(this.item){
       this.tooltip = this.item.actionTooltip;
       this.tooltipIsAlert = this.item.actionIsAlert;;
    }
    if (this.adjust(this.tabs)) this.tabs.forEach(text => this.tabInvalids.push(false));    //editorで更新するのでcolumnStyleを考慮したタブ数に合わせる

    if (this.owner != null) {
      //リストビューにsetStateへのアクセスを提供する
      if (this.isFullSizeEditor) this.owner.editor = this;
      else this.owner.sideEditor = this;

      //ダイアログ表示する際の高さを調整
      this.owner.editorHalfHeight = this.tabs && this.tabs.length == 1;

      //イベントをバインドする
      this.$on('cancel', this.owner.onCancel);
      this.$on('close', this.owner.onClose);//閲覧モードでdialog表示するため、ターゲットメソッドを分離
      this.$on('execute', this.owner.onExec);
      this.owner.$on('resize',this.onResize);
    }

    this.actionTooltipVisible =  localStorage.actionTooltipVisible == null ||  localStorage.actionTooltipVisible == 'true';
  }

  public mounted() {
    this.setState(Common.editorStates.Read);
    //権限チェックを行う
    this.actionDisabled = this.$api.perms.hasMenuPermission(this.perm) == false;
    this.onResize();//ロード直後に判定を実施
  }

   @Watch('actionTooltipVisible')
  public onSideFilterChanged() {
    localStorage.actionTooltipVisible = this.actionTooltipVisible;
  } 
  @Watch('item')
  public onItemChanged(){
    //行選択変更時とワークフローアクション実行後に呼び出されます。
    if (this.item){
      this.tooltip = this.item.actionTooltip;
      this.tooltipIsAlert = this.item.actionIsAlert;
      //アクションツールチップを停止したため以下コメント
      // if(this.tooltipComponent) this.tooltipComponent.$destroy();    
      // if(this.tooltip) this.$nextTick(()=>{
      //   this.tooltipComponent = this.$api.tooltip.mount(this, this.$refs.tooltip_target as Element,this.tooltip);
      // });    
      this.updateTabState();
    }
  }
  public tooltipComponent: Components.Tooltip;

  public destroyed() {
    document.body.removeEventListener('click', this.onClickOtherElement, { capture: true });
    document.body.removeEventListener('focusin', this.onClickOtherElement, { capture: true });
  }

  public onClickOtherElement(e: any) {
    if (this.editorState != Common.editorStates.Read) {
      console.log('outside click on editor');
      const modal = document.getElementById('builtinModal');
      const modal2 = document.getElementById('popupEditor');
      const modal3 = document.getElementById('workflowDialog');      
      const modal4 = document.getElementById('dialogEditor');  //ヘッダ部などで警告メッセージが表示されるのを回避                
      const tooltips = document.getElementsByClassName('tooltip'); // ツールチップクリック時の表示を回避
      // リンクとカードはクリックをハックする(フォーカスだとtargetがDIVだったりするため)
      // 入力コントロールはフォーカスをハックする
      if (this.$el.contains(e.srcElement)) {
        return;
      } else if (e.type == 'focusin' && e.srcElement.tagName.toLowerCase() != 'input' && e.srcElement.tagName.toLowerCase() != 'select') {
        return;
      } else if (modal != null && modal.contains(e.srcElement)) {
        return;
      } else if (modal2 != null && modal2.contains(e.srcElement)) {
        return;        
      } else if (modal3 != null && modal3.contains(e.srcElement)) {
        return;               
      } else if (modal4 != null && modal4.contains(e.srcElement)) {
        return;                        
      } else if (tooltips.length != 0 && tooltips[0].contains(e.srcElement)) {
        return;
      } else if ((e.srcElement as HTMLElement).className.includes('edit_focus') || (e.srcElement as HTMLElement).parentElement.className.includes('edit_focus')) {
        //ソースエレメントとその親にedit_focusクラスが付与されているかどうかを調べる。あまりネストするとパフォーマンスが悪くなるので。
        return;
      // } else if (e.srcElement.lastChild.id == 'spinner'){
      //   //オートコンプリートのスピナー
      //   return ;
      }else if (e.srcElement.closest(".modal-dialog")){ 
        //モーダルに含まれている場合は編集処理の一部として扱う
        return;
      }

      // //サイドバーの表示制御ボタンのクリックを許可=>左右配置で閉じる際は破棄したいのでコメント
      // if((e.srcElement as HTMLElement).id == 'sidebar_left' || (e.srcElement as HTMLElement).id == 'sidebar_right' )
      // {
      //   e.relatedTarget.focus();
      //   return;
      // }

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      this.source = e.relatedTarget; // フォーカス移動元
      this.target = e.srcElement; // フォーカス移動先
      this.$api.modal.show('確認メッセージ', '編集中のデータは保存されていません。破棄してもよろしいですか?', false, this.onExit,null,'破棄する','戻る');
      return false;
    }
  }
  /** 編集状態を解除してイベント処理を継続します。 */
  public onExit() {
    if (this.target != null) {
      this.setState(Common.editorStates.Read);
      this.$emit('cancel');
      this.$nextTick(() => {
        if (this.target.tagName.toLowerCase() == 'input' || this.target.tagName.toLowerCase() == 'select') {
          this.target.focus();
        } else {
          this.target.click();
        }
      });
    } else {
      this.source.focus();
    }
  }

  // #endregion

  // #region エディット状態の制御
  public isSubmitting=false;

  public submit() {
    //ダブルクリック防止
    if (this.isSubmitting) return;    
    this.isSubmitting = true;
    this.$nextTick(()=>this.isSubmitting = false);

    if (this.editorState === Common.editorStates.Read) {
      if (this.owner)this.owner.onEdit(); //バリデーションの実装
      else {
        this.setState(Common.editorStates.Edit);
        this.$emit('edit');
      }
    } else if (this.editorState === Common.editorStates.Edit) {
      if (this.validator.validate()) {
        //確認画面の廃止
        // this.setState(Common.editorStates.Confirm);
        this.$emit('execute', this.item);
      }
    } else if (this.editorState === Common.editorStates.Confirm) {
      //正常完了時のみエディタの状態を更新する=>制御はイベントハンドラに任せる。
      this.$emit('execute', this.item);

      // if (this.owner != null){
      //   this.owner.onExec(this.item).then(() => this.setState(Common.editorStates.Read));
      // } else {
      //   this.action(this.item).then(() => this.setState(Common.editorStates.Read));
      // }
    }
    this.updateTabState();    
  }
  public updateTabState(){
    if (this.$refs.tab){
      var invalidControls = this.controls.filter(ctrl =>ctrl.validator ? ctrl.validator.validateMessage : false);
      var tabs = (this.$refs.tab as Components.Tab).tabElements;
      tabs.forEach((el,index) =>{
          var tabOwned = invalidControls.filter(ctrl =>el.contains((ctrl as any as Vue).$el));
          this.$set(this.tabInvalids,index,tabOwned.length > 0);
      });
    }
  }
  public cancel() {
    if (this.editorState === Common.editorStates.Edit) {
      var isInsertMode = this.owner ? this.owner.isInsertMode : false;
      this.setState(Common.editorStates.Read);
      this.$emit('cancel');
      if (isInsertMode && this.owner && this.owner.popup){
        this.owner.popup.onClose();
      } else if (isInsertMode && this.$api.spMode && this.owner != null) {
        (this.owner as Components.ListView).setVisibleState('list');
      }
    } else if (this.editorState === Common.editorStates.Confirm) {
      this.setState(Common.editorStates.Edit);
    } else if (this.editorState === Common.editorStates.Read) {
      if (this.owner && this.owner.popup){
        this.owner.popup.onClose();
      } else if (this.$api.spMode && this.owner != null) {
        (this.owner as Components.ListView).setVisibleState('list');
      }
      this.$emit('close');
    }
    this.$nextTick(()=>this.updateTabState());        
  }
  public get isEdit(): boolean {
    return this.editorState != Common.editorStates.Read;
  }

  public isLoading:boolean = false;
  public setState(state: Common.editorStates) {
    this.editorState = state;
      var isInsertMode = this.owner ? this.owner.isInsertMode : false;
    // ボタンキャプション更新・コントロール編集状態制御
    if (state === Common.editorStates.Edit) {
      this.setControls(true);
      //新規追加or複製の場合は最初のタブを選択、編集時は現在のタブ（非ダイアログモード時）
      if (this.$refs.tab && isInsertMode) (this.$refs.tab as Components.Tab).onClick(0);
      if (this.controls.filter(obj =>obj.enabled).length == 0) {
        this.$api.modal.show("無効な操作",this.item.messageOnEdit,true,null);
        this.setControls(false);
        this.editorState = Common.editorStates.Read;
        if(this.owner) this.owner.onCancel();
        return;
      }
      //確認するの廃止
      // this.executeMessage = '確認する';
      // this.executeIcon = 'check';
      this.isLoading = true;
      window.setTimeout(()=>{
        this.executeMessage = this.execCaption;
        if (isInsertMode) this.executeMessage = '追加する';
        else this.executeIcon = 'update';      
        this.cancelMessage = 'キャンセル';
        this.cancelIcon = 'cancel';
        this.setControls(true);
        this.$api.sckeys.filter = (key:string) =>key == "F9" || key == "F12";
        this.$nextTick(() => this.focus());
        this.isLoading = false;
      },300);

    } else if (state === Common.editorStates.Confirm) {
      this.executeMessage = this.execCaption;
      this.executeIcon = 'update';
      this.cancelMessage = '戻る';
      this.cancelIcon = 'undo';
      this.setControls(false);
      this.$api.sckeys.filter = (key:string) =>key == "F9" || key == "F12";
    } else if (state === Common.editorStates.Read) {
      this.executeMessage = '編集する';
      this.executeIcon = 'edit';
      this.cancelMessage = '閉じる';
      this.cancelIcon = '';
      this.setControls(false);
      this.$api.sckeys.filter = null;
    }

    this.$forceUpdate();
  }

  setControls(isEdit: boolean) {
    this.controls.forEach(obj => (obj.isEdit = isEdit));
  }

  /**エディタの最初のコントロールにフォーカスをセットします */
  public focus() {
    // this.controls[0].focus();
    var focussableElements = 'a:not([disabled]), button:not([disabled]),select:not([disabled]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';
    if (this.$refs.tab0 != null) {
      const target = (this.$refs.tab0 as HTMLElement[])[0];
      var focussable = target.querySelectorAll(focussableElements);
      if (focussable != null && focussable.length > 0) {
        const input = focussable[0] as HTMLElement;
        input.focus();
      }
    }
  }
}
